import { useMemo } from "react";
// material
import { CssBaseline } from "@material-ui/core";
import {
    createTheme, ThemeProvider, StylesProvider,
} from "@material-ui/core/styles";
//
import palette from "./palette";
import typography from "./typography";
import componentsOverride from './overrides';
// ----------------------------------------------------------------------

export default function ThemeConfig({ children }) {

    const themeOptions = useMemo(() => ({
        palette: { ...palette.light },
        typography
    }), []);

    const theme = createTheme(themeOptions);
    theme.overrides = componentsOverride(theme);

    return (
        <StylesProvider injectFirst>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </StylesProvider>
    );
}
